"use strict";
exports.__esModule = true;
exports.SvgVersionCompare = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgVersionCompare = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M12 2a.75.75 0 01.75.75v18.5a.75.75 0 01-1.5 0v-1.549l-8.854-4.795a.741.741 0 01-.3-1.02.78.78 0 01.952-.335l.095.044 8.107 4.391v-2.258l-8.715-4.812a1.053 1.053 0 010-1.832l8.715-4.813V2.75A.75.75 0 0112 2zm9.903 11.886a.736.736 0 01-.211.964l-.088.056L15 18.482v-1.715l5.857-3.172a.78.78 0 011.046.29zM15 5.514l6.465 3.57a1.053 1.053 0 010 1.832L15 14.485v-1.776L19.907 10 15 7.29V5.514z" }),
        react_1["default"].createElement("path", { d: "M0 0h24v24H0z" })))); };
//# sourceMappingURL=VersionCompare.js.map